import { Outlet, NavLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../features/auth/authSlice";
import Header from "./Header";
import { useState } from "react";

export default function AdminLayout() {
    const dispatch = useDispatch();
    const [mobileOpen, setMobileOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [openMenu, setOpenMenu] = useState(null);

    const menuClass = ({ isActive }) =>
        `flex items-center gap-3 px-4 py-3 rounded-xl transition-all duration-200
        ${isActive
            ? "bg-gradient-to-r from-blue-100 to-white-600 text-white shadow-md"
            : "text-gray-400 hover:bg-gray-800 hover:text-white"
        }`;

    return (
        <div className="flex min-h-screen bg-gradient-to-br from-gray-100 to-gray-200">

            {/* Sidebar */}
            <aside
                className={`
                    ${collapsed ? "w-20" : "w-64"}
                    bg-blue-900 text-white
                    p-6
                    transition-all duration-300
                    hidden md:block
                `}
            >
                {/* Logo */}
                <div className="flex justify-between items-center mb-10">
                    {!collapsed && (
                        <div>
                            <h1 className="text-xl font-bold text-white">
                                WMS <span className="text-blue-500">Admin</span>
                            </h1>
                            <p className="text-gray-500 text-xs mt-1">
                                Warehouse Management
                            </p>
                        </div>
                    )}

                    <button
                        onClick={() => setCollapsed(!collapsed)}
                        className="hidden md:block text-gray-500 hover:text-white"
                    >
                        {collapsed ? "➡️" : "⬅️"}
                    </button>
                </div>

                {/* Menu */}
                <nav className="space-y-2">
                    {/* Dashboard Parent */}
                    <div>
                        <button
                            onClick={() =>
                                setOpenMenu(openMenu === "dashboard" ? null : "dashboard")
                            }
                            className="flex items-center justify-between w-full px-4 py-3 rounded-xl text-gray-400 hover:bg-gray-800 hover:text-white transition"
                        >
                            <span className="flex items-center gap-3">
                                📊 {!collapsed && "Dashboard"}
                            </span>
                            {!collapsed && <span>{openMenu === "dashboard" ? "▲" : "▼"}</span>}
                        </button>

                        {/* Sub Menu */}
                        {openMenu === "dashboard" && (
                            <div className="ml-6 mt-2 space-y-1">
                                <NavLink to="dashboard/overview" className={menuClass}>
                                    📈 {!collapsed && "Overview"}
                                </NavLink>

                                <NavLink to="datapalete" className={menuClass}>
                                    📊 {!collapsed && "Report"}
                                </NavLink>
                            </div>
                        )}
                    </div>

                    <NavLink to="palette" className={menuClass}>
                        📦 {!collapsed && "Master Palette"}
                    </NavLink>

                    <NavLink to="raking" className={menuClass}>
                        🗂️ {!collapsed && "Master Raking"}
                    </NavLink>

                    {/*<NavLink to="beginning-balance" className={menuClass}>
                        📤 {!collapsed && "Beginning Balance   "}
                    </NavLink>*/}

                    <NavLink to="report-stock" className={menuClass}>
                        🚚 {!collapsed && "Report Stock"}
                    </NavLink>

                </nav>

                {/* Logout bottom */}
                {/*<div className="bottom-6 left-6 right-6">
                    <button
                        onClick={() => dispatch(logout())}
                        className="w-full py-3 rounded-xl bg-orange-500 hover:bg-orange-600 text-white transition"
                    >
                        {!collapsed ? "Logout" : "🚪"}
                    </button>
                </div>*/}
            </aside>

            {/* Overlay Mobile */}
            {mobileOpen && (
            <div className="fixed inset-0 z-40 flex md:hidden">
                <div className="w-64 bg-gray-900 p-6">
                        <nav className="space-y-2">
                            <NavLink to="dashboard" className={menuClass}>
                                📊 {!collapsed && "Dashboard"}
                            </NavLink>

                            <NavLink to="inventory" className={menuClass}>
                                📦 {!collapsed && "Master Palette"}
                            </NavLink>

                            <NavLink to="raking" className={menuClass}>
                                🗂️ {!collapsed && "Master Raking"}
                            </NavLink>

                            {/*<NavLink to="beginning-balance" className={menuClass}>
                                📤 {!collapsed && "Beginning Balance   "}
                            </NavLink>*/}
                        </nav>
                </div>
                <div
                className="flex-1 bg-black/40"
                onClick={() => setMobileOpen(false)}
                />
            </div>
            )}

            {/* Main */}
            <div className="flex-1 flex flex-col transition-all duration-300">
                <Header
                    onMenuClick={() => setMobileOpen(!mobileOpen)}
                />

                <main className="flex-1 p-1">
                    <div className="bg-white rounded-1xl shadow-lg p-2 min-h-[calc(100vh-140px)] border border-gray-100 no-print print:border-0 print:shadow-none">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
}